var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDottedbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 386,
    viewBox: "0 0 423 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_510_37086)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 5.11327 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 5.11327 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 5.11327 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 5.11327 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 5.11327 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 5.11327 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 5.11327 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 5.11327 43.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 11.1719 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 11.1719 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 11.1719 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 11.1719 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 11.1719 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 11.1719 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 11.1719 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 11.1719 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 17.7344 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 17.7344 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 17.7344 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 17.7344 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 17.7344 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 17.7344 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 17.7344 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 17.7344 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 24.3008 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 24.3008 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 24.3008 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 24.3008 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 24.3008 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 24.3008 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 24.3008 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 24.3008 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 30.8633 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 30.8633 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 30.8633 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 30.8633 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 30.8633 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 30.8633 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 30.8633 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 30.8633 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 37.4219 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 37.4219 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 37.4219 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 37.4219 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 37.4219 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 37.4219 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 37.4219 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 37.4219 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 43.9844 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 43.9844 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 43.9844 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 43.9844 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 43.9844 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 43.9844 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 43.9844 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 43.9844 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 50.5508 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 50.5508 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 50.5508 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 50.5508 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 50.5508 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 50.5508 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 50.5508 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 50.5508 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 57.1133 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 57.1133 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 57.1133 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 57.1133 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 57.1133 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 57.1133 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 57.1133 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 57.1133 43.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 63.1719 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 63.1719 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 63.1719 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 63.1719 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 63.1719 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 63.1719 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 63.1719 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 63.1719 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 69.7344 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 69.7344 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 69.7344 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 69.7344 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 69.7344 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 69.7344 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 69.7344 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 69.7344 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 76.3008 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 76.3008 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 76.3008 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 76.3008 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 76.3008 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 76.3008 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 76.3008 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 76.3008 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 82.8633 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 82.8633 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 82.8633 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 82.8633 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 82.8633 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 82.8633 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 82.8633 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 82.8633 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 89.4219 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 89.4219 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 89.4219 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 89.4219 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 89.4219 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 89.4219 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 89.4219 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 89.4219 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 95.9844 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 95.9844 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 95.9844 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 95.9844 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 95.9844 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 95.9844 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 95.9844 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 95.9844 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 102.551 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 102.551 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 102.551 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 102.551 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 102.551 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 102.551 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 102.551 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 102.551 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 109.113 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 109.113 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 109.113 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 109.113 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 109.113 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 109.113 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 109.113 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 109.113 43.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 115.172 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 115.172 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 115.172 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 115.172 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 115.172 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 115.172 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 115.172 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 115.172 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 121.734 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 121.734 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 121.734 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 121.734 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 121.734 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 121.734 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 121.734 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 121.734 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 128.301 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 128.301 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 128.301 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 128.301 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 128.301 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 128.301 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 128.301 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 128.301 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 134.863 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 134.863 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 134.863 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 134.863 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 134.863 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 134.863 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 134.863 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 134.863 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 141.422 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 141.422 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 141.422 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 141.422 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 141.422 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 141.422 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 141.422 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 141.422 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 147.984 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 147.984 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 147.984 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 147.984 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 147.984 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 147.984 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 147.984 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 147.984 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 154.551 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 154.551 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 154.551 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 154.551 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 154.551 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 154.551 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 154.551 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 154.551 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 161.113 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 161.113 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 161.113 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 161.113 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 161.113 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 161.113 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 161.113 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 161.113 43.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 167.172 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 167.172 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 167.172 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 167.172 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 167.172 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 167.172 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 167.172 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 167.172 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 173.734 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 173.734 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 173.734 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 173.734 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 173.734 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 173.734 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 173.734 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 173.734 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 180.301 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 180.301 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 180.301 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 180.301 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 180.301 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 180.301 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 180.301 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 180.301 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 186.863 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 186.863 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 186.863 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 186.863 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 186.863 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 186.863 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 186.863 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 186.863 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 193.422 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 193.422 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 193.422 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 193.422 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 193.422 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 193.422 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 193.422 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 193.422 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 199.984 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 199.984 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 199.984 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 199.984 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 199.984 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 199.984 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 199.984 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 199.984 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 206.551 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 206.551 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 206.551 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 206.551 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 206.551 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 206.551 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 206.551 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 206.551 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 213.113 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 213.113 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 213.113 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 213.113 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 213.113 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 213.113 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 213.113 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 213.113 43.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 219.172 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 219.172 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 219.172 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 219.172 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 219.172 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 219.172 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 219.172 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 219.172 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 225.734 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 225.734 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 225.734 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 225.734 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 225.734 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 225.734 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 225.734 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 225.734 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 232.301 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 232.301 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 232.301 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 232.301 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 232.301 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 232.301 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 232.301 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 232.301 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 238.863 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 238.863 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 238.863 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 238.863 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 238.863 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 238.863 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 238.863 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 238.863 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 245.422 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 245.422 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 245.422 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 245.422 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 245.422 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 245.422 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 245.422 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 245.422 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 251.984 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 251.984 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 251.984 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 251.984 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 251.984 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 251.984 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 251.984 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 251.984 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 258.551 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 258.551 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 258.551 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 258.551 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 258.551 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 258.551 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 258.551 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 258.551 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 265.113 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 265.113 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 265.113 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 265.113 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 265.113 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 265.113 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 265.113 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 265.113 43.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 271.172 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 271.172 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 271.172 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 271.172 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 271.172 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 271.172 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 271.172 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 271.172 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 277.734 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 277.734 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 277.734 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 277.734 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 277.734 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 277.734 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 277.734 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 277.734 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 284.301 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 284.301 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 284.301 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 284.301 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 284.301 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 284.301 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 284.301 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 284.301 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 290.863 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 290.863 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 290.863 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 290.863 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 290.863 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 290.863 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 290.863 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 290.863 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 297.422 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 297.422 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 297.422 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 297.422 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 297.422 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 297.422 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 297.422 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 297.422 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 303.984 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 303.984 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 303.984 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 303.984 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 303.984 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 303.984 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 303.984 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 303.984 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 310.551 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 310.551 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 310.551 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 310.551 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 310.551 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 310.551 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 310.551 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 310.551 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 317.113 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 317.113 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 317.113 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 317.113 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 317.113 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 317.113 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 317.113 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 317.113 43.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 323.172 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 323.172 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 323.172 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 323.172 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 323.172 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 323.172 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 323.172 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 323.172 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 329.734 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 329.734 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 329.734 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 329.734 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 329.734 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 329.734 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 329.734 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 329.734 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 336.301 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 336.301 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 336.301 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 336.301 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 336.301 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 336.301 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 336.301 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 336.301 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 342.863 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 342.863 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 342.863 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 342.863 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 342.863 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 342.863 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 342.863 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 342.863 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 349.422 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 349.422 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 349.422 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 349.422 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 349.422 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 349.422 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 349.422 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 349.422 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 355.984 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 355.984 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 355.984 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 355.984 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 355.984 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 355.984 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 355.984 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 355.984 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 362.551 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 362.551 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 362.551 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 362.551 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 362.551 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 362.551 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 362.551 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 362.551 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 369.113 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 369.113 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 369.113 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 369.113 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 369.113 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 369.113 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 369.113 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 369.113 43.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 375.172 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 375.172 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 375.172 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 375.172 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 375.172 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 375.172 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 375.172 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 375.172 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 381.734 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 381.734 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 381.734 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 381.734 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 381.734 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 381.734 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 381.734 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 381.734 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 388.301 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 388.301 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 388.301 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 388.301 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 388.301 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 388.301 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 388.301 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 388.301 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 394.863 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 394.863 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 394.863 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 394.863 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 394.863 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 394.863 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 394.863 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 394.863 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 401.422 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 401.422 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 401.422 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 401.422 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 401.422 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 401.422 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 401.422 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 401.422 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 407.984 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 407.984 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 407.984 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 407.984 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 407.984 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 407.984 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 407.984 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 407.984 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 414.551 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 414.551 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 414.551 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 414.551 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 414.551 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 414.551 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 414.551 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 414.551 43.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 1.17189,
    r: 1.17189,
    transform: "rotate(90 421.113 1.17189)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 13.3594,
    r: 1.17189,
    transform: "rotate(90 421.113 13.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 25.5469,
    r: 1.17189,
    transform: "rotate(90 421.113 25.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 37.7354,
    r: 1.17189,
    transform: "rotate(90 421.113 37.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 7.26661,
    r: 1.17189,
    transform: "rotate(90 421.113 7.26661)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 19.4541,
    r: 1.17189,
    transform: "rotate(90 421.113 19.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 31.6406,
    r: 1.17189,
    transform: "rotate(90 421.113 31.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 43.8281,
    r: 1.17189,
    transform: "rotate(90 421.113 43.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 5.11327 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 5.11327 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 5.11327 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 5.11327 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 5.11327 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 5.11327 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 5.11327 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 5.11327 92.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 11.1719 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 11.1719 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 11.1719 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 11.1719 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 11.1719 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 11.1719 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 11.1719 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 11.1719 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 17.7344 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 17.7344 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 17.7344 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 17.7344 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 17.7344 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 17.7344 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 17.7344 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 17.7344 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 24.3008 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 24.3008 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 24.3008 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 24.3008 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 24.3008 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 24.3008 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 24.3008 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 24.3008 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 30.8633 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 30.8633 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 30.8633 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 30.8633 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 30.8633 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 30.8633 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 30.8633 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 30.8633 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 37.4219 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 37.4219 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 37.4219 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 37.4219 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 37.4219 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 37.4219 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 37.4219 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 37.4219 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 43.9844 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 43.9844 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 43.9844 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 43.9844 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 43.9844 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 43.9844 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 43.9844 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 43.9844 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 50.5508 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 50.5508 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 50.5508 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 50.5508 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 50.5508 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 50.5508 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 50.5508 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 50.5508 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 57.1133 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 57.1133 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 57.1133 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 57.1133 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 57.1133 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 57.1133 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 57.1133 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 57.1133 92.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 63.1719 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 63.1719 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 63.1719 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 63.1719 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 63.1719 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 63.1719 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 63.1719 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 63.1719 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 69.7344 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 69.7344 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 69.7344 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 69.7344 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 69.7344 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 69.7344 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 69.7344 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 69.7344 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 76.3008 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 76.3008 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 76.3008 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 76.3008 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 76.3008 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 76.3008 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 76.3008 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 76.3008 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 82.8633 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 82.8633 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 82.8633 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 82.8633 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 82.8633 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 82.8633 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 82.8633 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 82.8633 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 89.4219 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 89.4219 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 89.4219 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 89.4219 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 89.4219 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 89.4219 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 89.4219 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 89.4219 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 95.9844 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 95.9844 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 95.9844 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 95.9844 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 95.9844 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 95.9844 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 95.9844 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 95.9844 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 102.551 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 102.551 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 102.551 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 102.551 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 102.551 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 102.551 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 102.551 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 102.551 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 109.113 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 109.113 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 109.113 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 109.113 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 109.113 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 109.113 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 109.113 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 109.113 92.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 115.172 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 115.172 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 115.172 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 115.172 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 115.172 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 115.172 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 115.172 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 115.172 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 121.734 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 121.734 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 121.734 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 121.734 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 121.734 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 121.734 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 121.734 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 121.734 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 128.301 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 128.301 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 128.301 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 128.301 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 128.301 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 128.301 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 128.301 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 128.301 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 134.863 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 134.863 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 134.863 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 134.863 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 134.863 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 134.863 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 134.863 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 134.863 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 141.422 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 141.422 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 141.422 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 141.422 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 141.422 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 141.422 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 141.422 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 141.422 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 147.984 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 147.984 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 147.984 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 147.984 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 147.984 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 147.984 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 147.984 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 147.984 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 154.551 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 154.551 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 154.551 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 154.551 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 154.551 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 154.551 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 154.551 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 154.551 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 161.113 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 161.113 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 161.113 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 161.113 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 161.113 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 161.113 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 161.113 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 161.113 92.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 167.172 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 167.172 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 167.172 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 167.172 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 167.172 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 167.172 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 167.172 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 167.172 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 173.734 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 173.734 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 173.734 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 173.734 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 173.734 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 173.734 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 173.734 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 173.734 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 180.301 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 180.301 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 180.301 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 180.301 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 180.301 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 180.301 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 180.301 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 180.301 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 186.863 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 186.863 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 186.863 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 186.863 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 186.863 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 186.863 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 186.863 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 186.863 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 193.422 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 193.422 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 193.422 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 193.422 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 193.422 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 193.422 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 193.422 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 193.422 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 199.984 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 199.984 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 199.984 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 199.984 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 199.984 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 199.984 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 199.984 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 199.984 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 206.551 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 206.551 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 206.551 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 206.551 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 206.551 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 206.551 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 206.551 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 206.551 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 213.113 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 213.113 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 213.113 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 213.113 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 213.113 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 213.113 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 213.113 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 213.113 92.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 219.172 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 219.172 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 219.172 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 219.172 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 219.172 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 219.172 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 219.172 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 219.172 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 225.734 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 225.734 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 225.734 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 225.734 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 225.734 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 225.734 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 225.734 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 225.734 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 232.301 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 232.301 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 232.301 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 232.301 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 232.301 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 232.301 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 232.301 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 232.301 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 238.863 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 238.863 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 238.863 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 238.863 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 238.863 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 238.863 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 238.863 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 238.863 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 245.422 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 245.422 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 245.422 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 245.422 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 245.422 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 245.422 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 245.422 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 245.422 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 251.984 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 251.984 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 251.984 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 251.984 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 251.984 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 251.984 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 251.984 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 251.984 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 258.551 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 258.551 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 258.551 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 258.551 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 258.551 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 258.551 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 258.551 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 258.551 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 265.113 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 265.113 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 265.113 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 265.113 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 265.113 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 265.113 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 265.113 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 265.113 92.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 271.172 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 271.172 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 271.172 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 271.172 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 271.172 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 271.172 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 271.172 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 271.172 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 277.734 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 277.734 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 277.734 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 277.734 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 277.734 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 277.734 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 277.734 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 277.734 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 284.301 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 284.301 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 284.301 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 284.301 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 284.301 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 284.301 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 284.301 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 284.301 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 290.863 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 290.863 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 290.863 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 290.863 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 290.863 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 290.863 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 290.863 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 290.863 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 297.422 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 297.422 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 297.422 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 297.422 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 297.422 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 297.422 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 297.422 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 297.422 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 303.984 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 303.984 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 303.984 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 303.984 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 303.984 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 303.984 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 303.984 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 303.984 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 310.551 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 310.551 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 310.551 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 310.551 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 310.551 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 310.551 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 310.551 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 310.551 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 317.113 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 317.113 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 317.113 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 317.113 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 317.113 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 317.113 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 317.113 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 317.113 92.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 323.172 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 323.172 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 323.172 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 323.172 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 323.172 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 323.172 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 323.172 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 323.172 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 329.734 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 329.734 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 329.734 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 329.734 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 329.734 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 329.734 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 329.734 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 329.734 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 336.301 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 336.301 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 336.301 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 336.301 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 336.301 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 336.301 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 336.301 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 336.301 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 342.863 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 342.863 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 342.863 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 342.863 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 342.863 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 342.863 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 342.863 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 342.863 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 349.422 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 349.422 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 349.422 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 349.422 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 349.422 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 349.422 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 349.422 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 349.422 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 355.984 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 355.984 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 355.984 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 355.984 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 355.984 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 355.984 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 355.984 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 355.984 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 362.551 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 362.551 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 362.551 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 362.551 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 362.551 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 362.551 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 362.551 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 362.551 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 369.113 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 369.113 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 369.113 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 369.113 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 369.113 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 369.113 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 369.113 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 369.113 92.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 375.172 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 375.172 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 375.172 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 375.172 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 375.172 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 375.172 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 375.172 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 375.172 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 381.734 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 381.734 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 381.734 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 381.734 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 381.734 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 381.734 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 381.734 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 381.734 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 388.301 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 388.301 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 388.301 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 388.301 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 388.301 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 388.301 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 388.301 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 388.301 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 394.863 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 394.863 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 394.863 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 394.863 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 394.863 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 394.863 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 394.863 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 394.863 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 401.422 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 401.422 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 401.422 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 401.422 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 401.422 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 401.422 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 401.422 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 401.422 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 407.984 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 407.984 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 407.984 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 407.984 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 407.984 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 407.984 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 407.984 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 407.984 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 414.551 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 414.551 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 414.551 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 414.551 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 414.551 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 414.551 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 414.551 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 414.551 92.8281)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 50.1719,
    r: 1.17189,
    transform: "rotate(90 421.113 50.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 62.3594,
    r: 1.17189,
    transform: "rotate(90 421.113 62.3594)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 74.5469,
    r: 1.17189,
    transform: "rotate(90 421.113 74.5469)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 86.7354,
    r: 1.17189,
    transform: "rotate(90 421.113 86.7354)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 56.2666,
    r: 1.17189,
    transform: "rotate(90 421.113 56.2666)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 68.4541,
    r: 1.17189,
    transform: "rotate(90 421.113 68.4541)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 80.6406,
    r: 1.17189,
    transform: "rotate(90 421.113 80.6406)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 92.8281,
    r: 1.17189,
    transform: "rotate(90 421.113 92.8281)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 5.11327 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 5.11327 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 5.11327 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 5.11327 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 5.11327 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 5.11327 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 5.11327 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 5.11327 141.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 11.1719 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 11.1719 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 11.1719 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 11.1719 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 11.1719 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 11.1719 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 11.1719 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 11.1719 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 17.7344 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 17.7344 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 17.7344 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 17.7344 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 17.7344 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 17.7344 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 17.7344 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 17.7344 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 24.3008 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 24.3008 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 24.3008 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 24.3008 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 24.3008 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 24.3008 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 24.3008 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 24.3008 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 30.8633 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 30.8633 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 30.8633 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 30.8633 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 30.8633 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 30.8633 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 30.8633 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 30.8633 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 37.4219 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 37.4219 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 37.4219 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 37.4219 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 37.4219 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 37.4219 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 37.4219 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 37.4219 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 43.9844 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 43.9844 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 43.9844 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 43.9844 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 43.9844 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 43.9844 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 43.9844 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 43.9844 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 50.5508 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 50.5508 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 50.5508 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 50.5508 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 50.5508 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 50.5508 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 50.5508 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 50.5508 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 57.1133 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 57.1133 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 57.1133 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 57.1133 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 57.1133 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 57.1133 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 57.1133 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 57.1133 141.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 63.1719 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 63.1719 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 63.1719 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 63.1719 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 63.1719 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 63.1719 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 63.1719 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 63.1719 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 69.7344 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 69.7344 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 69.7344 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 69.7344 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 69.7344 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 69.7344 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 69.7344 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 69.7344 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 76.3008 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 76.3008 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 76.3008 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 76.3008 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 76.3008 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 76.3008 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 76.3008 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 76.3008 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 82.8633 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 82.8633 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 82.8633 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 82.8633 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 82.8633 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 82.8633 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 82.8633 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 82.8633 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 89.4219 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 89.4219 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 89.4219 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 89.4219 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 89.4219 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 89.4219 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 89.4219 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 89.4219 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 95.9844 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 95.9844 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 95.9844 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 95.9844 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 95.9844 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 95.9844 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 95.9844 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 95.9844 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 102.551 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 102.551 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 102.551 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 102.551 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 102.551 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 102.551 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 102.551 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 102.551 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 109.113 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 109.113 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 109.113 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 109.113 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 109.113 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 109.113 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 109.113 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 109.113 141.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 115.172 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 115.172 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 115.172 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 115.172 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 115.172 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 115.172 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 115.172 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 115.172 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 121.734 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 121.734 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 121.734 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 121.734 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 121.734 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 121.734 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 121.734 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 121.734 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 128.301 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 128.301 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 128.301 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 128.301 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 128.301 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 128.301 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 128.301 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 128.301 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 134.863 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 134.863 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 134.863 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 134.863 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 134.863 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 134.863 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 134.863 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 134.863 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 141.422 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 141.422 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 141.422 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 141.422 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 141.422 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 141.422 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 141.422 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 141.422 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 147.984 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 147.984 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 147.984 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 147.984 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 147.984 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 147.984 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 147.984 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 147.984 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 154.551 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 154.551 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 154.551 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 154.551 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 154.551 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 154.551 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 154.551 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 154.551 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 161.113 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 161.113 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 161.113 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 161.113 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 161.113 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 161.113 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 161.113 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 161.113 141.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 167.172 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 167.172 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 167.172 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 167.172 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 167.172 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 167.172 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 167.172 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 167.172 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 173.734 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 173.734 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 173.734 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 173.734 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 173.734 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 173.734 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 173.734 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 173.734 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 180.301 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 180.301 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 180.301 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 180.301 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 180.301 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 180.301 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 180.301 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 180.301 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 186.863 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 186.863 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 186.863 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 186.863 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 186.863 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 186.863 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 186.863 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 186.863 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 193.422 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 193.422 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 193.422 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 193.422 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 193.422 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 193.422 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 193.422 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 193.422 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 199.984 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 199.984 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 199.984 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 199.984 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 199.984 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 199.984 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 199.984 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 199.984 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 206.551 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 206.551 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 206.551 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 206.551 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 206.551 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 206.551 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 206.551 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 206.551 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 213.113 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 213.113 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 213.113 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 213.113 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 213.113 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 213.113 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 213.113 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 213.113 141.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 219.172 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 219.172 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 219.172 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 219.172 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 219.172 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 219.172 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 219.172 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 219.172 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 225.734 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 225.734 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 225.734 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 225.734 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 225.734 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 225.734 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 225.734 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 225.734 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 232.301 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 232.301 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 232.301 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 232.301 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 232.301 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 232.301 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 232.301 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 232.301 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 238.863 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 238.863 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 238.863 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 238.863 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 238.863 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 238.863 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 238.863 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 238.863 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 245.422 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 245.422 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 245.422 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 245.422 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 245.422 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 245.422 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 245.422 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 245.422 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 251.984 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 251.984 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 251.984 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 251.984 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 251.984 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 251.984 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 251.984 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 251.984 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 258.551 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 258.551 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 258.551 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 258.551 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 258.551 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 258.551 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 258.551 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 258.551 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 265.113 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 265.113 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 265.113 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 265.113 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 265.113 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 265.113 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 265.113 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 265.113 141.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 271.172 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 271.172 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 271.172 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 271.172 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 271.172 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 271.172 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 271.172 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 271.172 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 277.734 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 277.734 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 277.734 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 277.734 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 277.734 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 277.734 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 277.734 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 277.734 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 284.301 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 284.301 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 284.301 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 284.301 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 284.301 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 284.301 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 284.301 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 284.301 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 290.863 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 290.863 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 290.863 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 290.863 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 290.863 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 290.863 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 290.863 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 290.863 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 297.422 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 297.422 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 297.422 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 297.422 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 297.422 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 297.422 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 297.422 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 297.422 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 303.984 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 303.984 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 303.984 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 303.984 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 303.984 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 303.984 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 303.984 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 303.984 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 310.551 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 310.551 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 310.551 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 310.551 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 310.551 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 310.551 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 310.551 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 310.551 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 317.113 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 317.113 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 317.113 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 317.113 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 317.113 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 317.113 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 317.113 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 317.113 141.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 323.172 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 323.172 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 323.172 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 323.172 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 323.172 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 323.172 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 323.172 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 323.172 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 329.734 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 329.734 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 329.734 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 329.734 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 329.734 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 329.734 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 329.734 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 329.734 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 336.301 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 336.301 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 336.301 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 336.301 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 336.301 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 336.301 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 336.301 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 336.301 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 342.863 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 342.863 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 342.863 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 342.863 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 342.863 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 342.863 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 342.863 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 342.863 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 349.422 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 349.422 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 349.422 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 349.422 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 349.422 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 349.422 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 349.422 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 349.422 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 355.984 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 355.984 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 355.984 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 355.984 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 355.984 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 355.984 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 355.984 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 355.984 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 362.551 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 362.551 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 362.551 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 362.551 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 362.551 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 362.551 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 362.551 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 362.551 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 369.113 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 369.113 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 369.113 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 369.113 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 369.113 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 369.113 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 369.113 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 369.113 141.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 375.172 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 375.172 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 375.172 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 375.172 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 375.172 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 375.172 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 375.172 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 375.172 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 381.734 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 381.734 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 381.734 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 381.734 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 381.734 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 381.734 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 381.734 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 381.734 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 388.301 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 388.301 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 388.301 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 388.301 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 388.301 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 388.301 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 388.301 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 388.301 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 394.863 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 394.863 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 394.863 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 394.863 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 394.863 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 394.863 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 394.863 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 394.863 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 401.422 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 401.422 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 401.422 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 401.422 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 401.422 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 401.422 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 401.422 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 401.422 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 407.984 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 407.984 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 407.984 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 407.984 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 407.984 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 407.984 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 407.984 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 407.984 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 414.551 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 414.551 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 414.551 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 414.551 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 414.551 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 414.551 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 414.551 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 414.551 141.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 99.1719,
    r: 1.17189,
    transform: "rotate(90 421.113 99.1719)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 111.359,
    r: 1.17189,
    transform: "rotate(90 421.113 111.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 123.547,
    r: 1.17189,
    transform: "rotate(90 421.113 123.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 135.735,
    r: 1.17189,
    transform: "rotate(90 421.113 135.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 105.267,
    r: 1.17189,
    transform: "rotate(90 421.113 105.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 117.454,
    r: 1.17189,
    transform: "rotate(90 421.113 117.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 129.641,
    r: 1.17189,
    transform: "rotate(90 421.113 129.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 141.828,
    r: 1.17189,
    transform: "rotate(90 421.113 141.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 5.11327 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 5.11327 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 5.11327 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 5.11327 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 5.11327 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 5.11327 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 5.11327 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 5.11327 190.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 11.1719 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 11.1719 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 11.1719 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 11.1719 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 11.1719 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 11.1719 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 11.1719 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 11.1719 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 17.7344 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 17.7344 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 17.7344 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 17.7344 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 17.7344 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 17.7344 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 17.7344 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 17.7344 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 24.3008 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 24.3008 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 24.3008 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 24.3008 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 24.3008 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 24.3008 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 24.3008 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 24.3008 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 30.8633 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 30.8633 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 30.8633 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 30.8633 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 30.8633 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 30.8633 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 30.8633 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 30.8633 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 37.4219 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 37.4219 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 37.4219 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 37.4219 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 37.4219 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 37.4219 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 37.4219 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 37.4219 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 43.9844 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 43.9844 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 43.9844 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 43.9844 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 43.9844 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 43.9844 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 43.9844 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 43.9844 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 50.5508 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 50.5508 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 50.5508 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 50.5508 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 50.5508 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 50.5508 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 50.5508 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 50.5508 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 57.1133 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 57.1133 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 57.1133 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 57.1133 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 57.1133 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 57.1133 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 57.1133 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 57.1133 190.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 63.1719 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 63.1719 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 63.1719 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 63.1719 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 63.1719 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 63.1719 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 63.1719 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 63.1719 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 69.7344 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 69.7344 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 69.7344 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 69.7344 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 69.7344 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 69.7344 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 69.7344 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 69.7344 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 76.3008 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 76.3008 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 76.3008 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 76.3008 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 76.3008 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 76.3008 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 76.3008 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 76.3008 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 82.8633 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 82.8633 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 82.8633 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 82.8633 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 82.8633 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 82.8633 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 82.8633 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 82.8633 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 89.4219 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 89.4219 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 89.4219 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 89.4219 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 89.4219 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 89.4219 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 89.4219 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 89.4219 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 95.9844 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 95.9844 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 95.9844 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 95.9844 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 95.9844 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 95.9844 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 95.9844 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 95.9844 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 102.551 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 102.551 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 102.551 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 102.551 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 102.551 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 102.551 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 102.551 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 102.551 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 109.113 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 109.113 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 109.113 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 109.113 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 109.113 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 109.113 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 109.113 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 109.113 190.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 115.172 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 115.172 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 115.172 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 115.172 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 115.172 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 115.172 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 115.172 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 115.172 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 121.734 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 121.734 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 121.734 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 121.734 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 121.734 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 121.734 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 121.734 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 121.734 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 128.301 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 128.301 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 128.301 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 128.301 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 128.301 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 128.301 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 128.301 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 128.301 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 134.863 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 134.863 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 134.863 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 134.863 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 134.863 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 134.863 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 134.863 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 134.863 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 141.422 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 141.422 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 141.422 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 141.422 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 141.422 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 141.422 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 141.422 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 141.422 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 147.984 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 147.984 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 147.984 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 147.984 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 147.984 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 147.984 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 147.984 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 147.984 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 154.551 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 154.551 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 154.551 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 154.551 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 154.551 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 154.551 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 154.551 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 154.551 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 161.113 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 161.113 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 161.113 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 161.113 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 161.113 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 161.113 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 161.113 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 161.113 190.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 167.172 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 167.172 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 167.172 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 167.172 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 167.172 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 167.172 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 167.172 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 167.172 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 173.734 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 173.734 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 173.734 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 173.734 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 173.734 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 173.734 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 173.734 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 173.734 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 180.301 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 180.301 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 180.301 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 180.301 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 180.301 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 180.301 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 180.301 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 180.301 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 186.863 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 186.863 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 186.863 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 186.863 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 186.863 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 186.863 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 186.863 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 186.863 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 193.422 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 193.422 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 193.422 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 193.422 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 193.422 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 193.422 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 193.422 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 193.422 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 199.984 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 199.984 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 199.984 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 199.984 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 199.984 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 199.984 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 199.984 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 199.984 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 206.551 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 206.551 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 206.551 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 206.551 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 206.551 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 206.551 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 206.551 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 206.551 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 213.113 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 213.113 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 213.113 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 213.113 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 213.113 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 213.113 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 213.113 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 213.113 190.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 219.172 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 219.172 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 219.172 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 219.172 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 219.172 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 219.172 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 219.172 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 219.172 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 225.734 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 225.734 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 225.734 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 225.734 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 225.734 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 225.734 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 225.734 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 225.734 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 232.301 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 232.301 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 232.301 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 232.301 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 232.301 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 232.301 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 232.301 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 232.301 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 238.863 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 238.863 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 238.863 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 238.863 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 238.863 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 238.863 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 238.863 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 238.863 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 245.422 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 245.422 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 245.422 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 245.422 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 245.422 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 245.422 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 245.422 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 245.422 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 251.984 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 251.984 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 251.984 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 251.984 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 251.984 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 251.984 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 251.984 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 251.984 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 258.551 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 258.551 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 258.551 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 258.551 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 258.551 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 258.551 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 258.551 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 258.551 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 265.113 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 265.113 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 265.113 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 265.113 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 265.113 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 265.113 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 265.113 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 265.113 190.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 271.172 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 271.172 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 271.172 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 271.172 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 271.172 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 271.172 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 271.172 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 271.172 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 277.734 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 277.734 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 277.734 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 277.734 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 277.734 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 277.734 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 277.734 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 277.734 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 284.301 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 284.301 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 284.301 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 284.301 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 284.301 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 284.301 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 284.301 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 284.301 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 290.863 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 290.863 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 290.863 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 290.863 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 290.863 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 290.863 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 290.863 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 290.863 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 297.422 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 297.422 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 297.422 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 297.422 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 297.422 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 297.422 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 297.422 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 297.422 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 303.984 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 303.984 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 303.984 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 303.984 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 303.984 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 303.984 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 303.984 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 303.984 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 310.551 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 310.551 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 310.551 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 310.551 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 310.551 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 310.551 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 310.551 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 310.551 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 317.113 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 317.113 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 317.113 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 317.113 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 317.113 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 317.113 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 317.113 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 317.113 190.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 323.172 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 323.172 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 323.172 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 323.172 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 323.172 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 323.172 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 323.172 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 323.172 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 329.734 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 329.734 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 329.734 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 329.734 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 329.734 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 329.734 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 329.734 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 329.734 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 336.301 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 336.301 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 336.301 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 336.301 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 336.301 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 336.301 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 336.301 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 336.301 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 342.863 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 342.863 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 342.863 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 342.863 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 342.863 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 342.863 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 342.863 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 342.863 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 349.422 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 349.422 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 349.422 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 349.422 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 349.422 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 349.422 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 349.422 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 349.422 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 355.984 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 355.984 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 355.984 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 355.984 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 355.984 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 355.984 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 355.984 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 355.984 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 362.551 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 362.551 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 362.551 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 362.551 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 362.551 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 362.551 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 362.551 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 362.551 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 369.113 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 369.113 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 369.113 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 369.113 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 369.113 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 369.113 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 369.113 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 369.113 190.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 375.172 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 375.172 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 375.172 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 375.172 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 375.172 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 375.172 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 375.172 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 375.172 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 381.734 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 381.734 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 381.734 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 381.734 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 381.734 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 381.734 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 381.734 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 381.734 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 388.301 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 388.301 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 388.301 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 388.301 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 388.301 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 388.301 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 388.301 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 388.301 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 394.863 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 394.863 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 394.863 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 394.863 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 394.863 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 394.863 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 394.863 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 394.863 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 401.422 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 401.422 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 401.422 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 401.422 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 401.422 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 401.422 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 401.422 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 401.422 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 407.984 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 407.984 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 407.984 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 407.984 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 407.984 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 407.984 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 407.984 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 407.984 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 414.551 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 414.551 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 414.551 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 414.551 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 414.551 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 414.551 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 414.551 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 414.551 190.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 148.172,
    r: 1.17189,
    transform: "rotate(90 421.113 148.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 160.359,
    r: 1.17189,
    transform: "rotate(90 421.113 160.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 172.547,
    r: 1.17189,
    transform: "rotate(90 421.113 172.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 184.735,
    r: 1.17189,
    transform: "rotate(90 421.113 184.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 154.267,
    r: 1.17189,
    transform: "rotate(90 421.113 154.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 166.454,
    r: 1.17189,
    transform: "rotate(90 421.113 166.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 178.641,
    r: 1.17189,
    transform: "rotate(90 421.113 178.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 190.828,
    r: 1.17189,
    transform: "rotate(90 421.113 190.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 5.11327 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 5.11327 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 5.11327 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 5.11327 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 5.11327 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 5.11327 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 5.11327 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 5.11327 239.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 11.1719 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 11.1719 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 11.1719 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 11.1719 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 11.1719 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 11.1719 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 11.1719 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 11.1719 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 17.7344 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 17.7344 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 17.7344 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 17.7344 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 17.7344 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 17.7344 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 17.7344 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 17.7344 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 24.3008 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 24.3008 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 24.3008 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 24.3008 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 24.3008 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 24.3008 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 24.3008 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 24.3008 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 30.8633 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 30.8633 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 30.8633 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 30.8633 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 30.8633 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 30.8633 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 30.8633 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 30.8633 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 37.4219 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 37.4219 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 37.4219 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 37.4219 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 37.4219 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 37.4219 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 37.4219 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 37.4219 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 43.9844 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 43.9844 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 43.9844 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 43.9844 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 43.9844 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 43.9844 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 43.9844 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 43.9844 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 50.5508 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 50.5508 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 50.5508 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 50.5508 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 50.5508 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 50.5508 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 50.5508 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 50.5508 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 57.1133 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 57.1133 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 57.1133 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 57.1133 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 57.1133 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 57.1133 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 57.1133 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 57.1133 239.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 63.1719 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 63.1719 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 63.1719 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 63.1719 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 63.1719 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 63.1719 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 63.1719 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 63.1719 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 69.7344 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 69.7344 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 69.7344 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 69.7344 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 69.7344 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 69.7344 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 69.7344 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 69.7344 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 76.3008 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 76.3008 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 76.3008 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 76.3008 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 76.3008 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 76.3008 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 76.3008 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 76.3008 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 82.8633 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 82.8633 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 82.8633 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 82.8633 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 82.8633 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 82.8633 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 82.8633 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 82.8633 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 89.4219 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 89.4219 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 89.4219 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 89.4219 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 89.4219 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 89.4219 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 89.4219 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 89.4219 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 95.9844 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 95.9844 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 95.9844 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 95.9844 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 95.9844 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 95.9844 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 95.9844 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 95.9844 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 102.551 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 102.551 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 102.551 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 102.551 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 102.551 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 102.551 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 102.551 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 102.551 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 109.113 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 109.113 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 109.113 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 109.113 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 109.113 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 109.113 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 109.113 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 109.113 239.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 115.172 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 115.172 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 115.172 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 115.172 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 115.172 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 115.172 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 115.172 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 115.172 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 121.734 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 121.734 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 121.734 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 121.734 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 121.734 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 121.734 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 121.734 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 121.734 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 128.301 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 128.301 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 128.301 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 128.301 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 128.301 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 128.301 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 128.301 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 128.301 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 134.863 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 134.863 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 134.863 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 134.863 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 134.863 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 134.863 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 134.863 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 134.863 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 141.422 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 141.422 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 141.422 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 141.422 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 141.422 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 141.422 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 141.422 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 141.422 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 147.984 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 147.984 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 147.984 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 147.984 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 147.984 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 147.984 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 147.984 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 147.984 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 154.551 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 154.551 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 154.551 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 154.551 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 154.551 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 154.551 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 154.551 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 154.551 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 161.113 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 161.113 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 161.113 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 161.113 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 161.113 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 161.113 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 161.113 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 161.113 239.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 167.172 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 167.172 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 167.172 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 167.172 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 167.172 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 167.172 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 167.172 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 167.172 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 173.734 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 173.734 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 173.734 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 173.734 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 173.734 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 173.734 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 173.734 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 173.734 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 180.301 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 180.301 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 180.301 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 180.301 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 180.301 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 180.301 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 180.301 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 180.301 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 186.863 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 186.863 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 186.863 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 186.863 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 186.863 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 186.863 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 186.863 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 186.863 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 193.422 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 193.422 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 193.422 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 193.422 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 193.422 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 193.422 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 193.422 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 193.422 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 199.984 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 199.984 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 199.984 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 199.984 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 199.984 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 199.984 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 199.984 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 199.984 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 206.551 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 206.551 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 206.551 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 206.551 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 206.551 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 206.551 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 206.551 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 206.551 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 213.113 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 213.113 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 213.113 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 213.113 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 213.113 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 213.113 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 213.113 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 213.113 239.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 219.172 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 219.172 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 219.172 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 219.172 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 219.172 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 219.172 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 219.172 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 219.172 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 225.734 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 225.734 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 225.734 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 225.734 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 225.734 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 225.734 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 225.734 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 225.734 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 232.301 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 232.301 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 232.301 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 232.301 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 232.301 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 232.301 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 232.301 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 232.301 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 238.863 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 238.863 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 238.863 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 238.863 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 238.863 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 238.863 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 238.863 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 238.863 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 245.422 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 245.422 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 245.422 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 245.422 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 245.422 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 245.422 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 245.422 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 245.422 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 251.984 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 251.984 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 251.984 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 251.984 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 251.984 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 251.984 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 251.984 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 251.984 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 258.551 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 258.551 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 258.551 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 258.551 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 258.551 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 258.551 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 258.551 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 258.551 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 265.113 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 265.113 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 265.113 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 265.113 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 265.113 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 265.113 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 265.113 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 265.113 239.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 271.172 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 271.172 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 271.172 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 271.172 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 271.172 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 271.172 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 271.172 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 271.172 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 277.734 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 277.734 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 277.734 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 277.734 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 277.734 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 277.734 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 277.734 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 277.734 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 284.301 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 284.301 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 284.301 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 284.301 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 284.301 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 284.301 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 284.301 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 284.301 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 290.863 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 290.863 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 290.863 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 290.863 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 290.863 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 290.863 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 290.863 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 290.863 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 297.422 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 297.422 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 297.422 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 297.422 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 297.422 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 297.422 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 297.422 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 297.422 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 303.984 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 303.984 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 303.984 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 303.984 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 303.984 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 303.984 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 303.984 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 303.984 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 310.551 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 310.551 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 310.551 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 310.551 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 310.551 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 310.551 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 310.551 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 310.551 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 317.113 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 317.113 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 317.113 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 317.113 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 317.113 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 317.113 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 317.113 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 317.113 239.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 323.172 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 323.172 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 323.172 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 323.172 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 323.172 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 323.172 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 323.172 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 323.172 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 329.734 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 329.734 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 329.734 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 329.734 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 329.734 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 329.734 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 329.734 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 329.734 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 336.301 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 336.301 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 336.301 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 336.301 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 336.301 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 336.301 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 336.301 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 336.301 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 342.863 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 342.863 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 342.863 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 342.863 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 342.863 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 342.863 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 342.863 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 342.863 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 349.422 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 349.422 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 349.422 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 349.422 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 349.422 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 349.422 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 349.422 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 349.422 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 355.984 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 355.984 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 355.984 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 355.984 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 355.984 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 355.984 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 355.984 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 355.984 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 362.551 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 362.551 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 362.551 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 362.551 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 362.551 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 362.551 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 362.551 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 362.551 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 369.113 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 369.113 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 369.113 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 369.113 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 369.113 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 369.113 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 369.113 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 369.113 239.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 375.172 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 375.172 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 375.172 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 375.172 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 375.172 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 375.172 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 375.172 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 375.172 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 381.734 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 381.734 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 381.734 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 381.734 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 381.734 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 381.734 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 381.734 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 381.734 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 388.301 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 388.301 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 388.301 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 388.301 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 388.301 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 388.301 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 388.301 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 388.301 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 394.863 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 394.863 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 394.863 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 394.863 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 394.863 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 394.863 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 394.863 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 394.863 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 401.422 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 401.422 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 401.422 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 401.422 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 401.422 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 401.422 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 401.422 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 401.422 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 407.984 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 407.984 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 407.984 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 407.984 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 407.984 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 407.984 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 407.984 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 407.984 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 414.551 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 414.551 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 414.551 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 414.551 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 414.551 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 414.551 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 414.551 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 414.551 239.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 197.172,
    r: 1.17189,
    transform: "rotate(90 421.113 197.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 209.359,
    r: 1.17189,
    transform: "rotate(90 421.113 209.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 221.547,
    r: 1.17189,
    transform: "rotate(90 421.113 221.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 233.735,
    r: 1.17189,
    transform: "rotate(90 421.113 233.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 203.267,
    r: 1.17189,
    transform: "rotate(90 421.113 203.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 215.454,
    r: 1.17189,
    transform: "rotate(90 421.113 215.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 227.641,
    r: 1.17189,
    transform: "rotate(90 421.113 227.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 239.828,
    r: 1.17189,
    transform: "rotate(90 421.113 239.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 5.11327 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 5.11327 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 5.11327 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 5.11327 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 5.11327 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 5.11327 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 5.11327 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 5.11327 288.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 11.1719 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 11.1719 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 11.1719 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 11.1719 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 11.1719 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 11.1719 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 11.1719 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 11.1719 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 17.7344 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 17.7344 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 17.7344 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 17.7344 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 17.7344 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 17.7344 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 17.7344 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 17.7344 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 24.3008 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 24.3008 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 24.3008 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 24.3008 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 24.3008 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 24.3008 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 24.3008 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 24.3008 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 30.8633 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 30.8633 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 30.8633 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 30.8633 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 30.8633 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 30.8633 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 30.8633 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 30.8633 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 37.4219 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 37.4219 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 37.4219 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 37.4219 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 37.4219 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 37.4219 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 37.4219 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 37.4219 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 43.9844 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 43.9844 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 43.9844 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 43.9844 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 43.9844 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 43.9844 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 43.9844 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 43.9844 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 50.5508 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 50.5508 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 50.5508 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 50.5508 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 50.5508 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 50.5508 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 50.5508 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 50.5508 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 57.1133 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 57.1133 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 57.1133 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 57.1133 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 57.1133 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 57.1133 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 57.1133 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 57.1133 288.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 63.1719 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 63.1719 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 63.1719 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 63.1719 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 63.1719 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 63.1719 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 63.1719 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 63.1719 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 69.7344 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 69.7344 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 69.7344 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 69.7344 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 69.7344 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 69.7344 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 69.7344 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 69.7344 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 76.3008 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 76.3008 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 76.3008 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 76.3008 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 76.3008 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 76.3008 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 76.3008 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 76.3008 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 82.8633 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 82.8633 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 82.8633 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 82.8633 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 82.8633 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 82.8633 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 82.8633 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 82.8633 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 89.4219 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 89.4219 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 89.4219 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 89.4219 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 89.4219 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 89.4219 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 89.4219 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 89.4219 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 95.9844 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 95.9844 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 95.9844 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 95.9844 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 95.9844 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 95.9844 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 95.9844 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 95.9844 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 102.551 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 102.551 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 102.551 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 102.551 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 102.551 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 102.551 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 102.551 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 102.551 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 109.113 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 109.113 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 109.113 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 109.113 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 109.113 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 109.113 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 109.113 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 109.113 288.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 115.172 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 115.172 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 115.172 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 115.172 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 115.172 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 115.172 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 115.172 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 115.172 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 121.734 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 121.734 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 121.734 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 121.734 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 121.734 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 121.734 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 121.734 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 121.734 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 128.301 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 128.301 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 128.301 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 128.301 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 128.301 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 128.301 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 128.301 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 128.301 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 134.863 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 134.863 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 134.863 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 134.863 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 134.863 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 134.863 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 134.863 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 134.863 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 141.422 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 141.422 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 141.422 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 141.422 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 141.422 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 141.422 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 141.422 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 141.422 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 147.984 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 147.984 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 147.984 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 147.984 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 147.984 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 147.984 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 147.984 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 147.984 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 154.551 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 154.551 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 154.551 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 154.551 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 154.551 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 154.551 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 154.551 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 154.551 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 161.113 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 161.113 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 161.113 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 161.113 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 161.113 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 161.113 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 161.113 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 161.113 288.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 167.172 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 167.172 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 167.172 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 167.172 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 167.172 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 167.172 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 167.172 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 167.172 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 173.734 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 173.734 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 173.734 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 173.734 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 173.734 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 173.734 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 173.734 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 173.734 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 180.301 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 180.301 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 180.301 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 180.301 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 180.301 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 180.301 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 180.301 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 180.301 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 186.863 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 186.863 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 186.863 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 186.863 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 186.863 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 186.863 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 186.863 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 186.863 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 193.422 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 193.422 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 193.422 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 193.422 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 193.422 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 193.422 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 193.422 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 193.422 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 199.984 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 199.984 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 199.984 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 199.984 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 199.984 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 199.984 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 199.984 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 199.984 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 206.551 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 206.551 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 206.551 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 206.551 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 206.551 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 206.551 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 206.551 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 206.551 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 213.113 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 213.113 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 213.113 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 213.113 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 213.113 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 213.113 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 213.113 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 213.113 288.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 219.172 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 219.172 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 219.172 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 219.172 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 219.172 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 219.172 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 219.172 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 219.172 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 225.734 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 225.734 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 225.734 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 225.734 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 225.734 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 225.734 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 225.734 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 225.734 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 232.301 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 232.301 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 232.301 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 232.301 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 232.301 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 232.301 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 232.301 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 232.301 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 238.863 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 238.863 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 238.863 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 238.863 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 238.863 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 238.863 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 238.863 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 238.863 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 245.422 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 245.422 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 245.422 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 245.422 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 245.422 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 245.422 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 245.422 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 245.422 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 251.984 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 251.984 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 251.984 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 251.984 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 251.984 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 251.984 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 251.984 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 251.984 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 258.551 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 258.551 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 258.551 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 258.551 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 258.551 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 258.551 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 258.551 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 258.551 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 265.113 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 265.113 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 265.113 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 265.113 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 265.113 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 265.113 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 265.113 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 265.113 288.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 271.172 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 271.172 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 271.172 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 271.172 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 271.172 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 271.172 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 271.172 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 271.172 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 277.734 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 277.734 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 277.734 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 277.734 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 277.734 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 277.734 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 277.734 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 277.734 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 284.301 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 284.301 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 284.301 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 284.301 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 284.301 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 284.301 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 284.301 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 284.301 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 290.863 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 290.863 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 290.863 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 290.863 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 290.863 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 290.863 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 290.863 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 290.863 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 297.422 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 297.422 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 297.422 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 297.422 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 297.422 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 297.422 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 297.422 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 297.422 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 303.984 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 303.984 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 303.984 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 303.984 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 303.984 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 303.984 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 303.984 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 303.984 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 310.551 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 310.551 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 310.551 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 310.551 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 310.551 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 310.551 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 310.551 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 310.551 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 317.113 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 317.113 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 317.113 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 317.113 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 317.113 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 317.113 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 317.113 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 317.113 288.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 323.172 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 323.172 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 323.172 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 323.172 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 323.172 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 323.172 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 323.172 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 323.172 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 329.734 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 329.734 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 329.734 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 329.734 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 329.734 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 329.734 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 329.734 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 329.734 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 336.301 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 336.301 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 336.301 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 336.301 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 336.301 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 336.301 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 336.301 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 336.301 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 342.863 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 342.863 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 342.863 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 342.863 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 342.863 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 342.863 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 342.863 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 342.863 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 349.422 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 349.422 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 349.422 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 349.422 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 349.422 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 349.422 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 349.422 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 349.422 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 355.984 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 355.984 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 355.984 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 355.984 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 355.984 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 355.984 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 355.984 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 355.984 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 362.551 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 362.551 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 362.551 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 362.551 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 362.551 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 362.551 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 362.551 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 362.551 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 369.113 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 369.113 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 369.113 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 369.113 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 369.113 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 369.113 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 369.113 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 369.113 288.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 375.172 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 375.172 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 375.172 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 375.172 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 375.172 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 375.172 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 375.172 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 375.172 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 381.734 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 381.734 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 381.734 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 381.734 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 381.734 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 381.734 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 381.734 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 381.734 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 388.301 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 388.301 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 388.301 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 388.301 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 388.301 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 388.301 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 388.301 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 388.301 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 394.863 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 394.863 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 394.863 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 394.863 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 394.863 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 394.863 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 394.863 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 394.863 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 401.422 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 401.422 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 401.422 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 401.422 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 401.422 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 401.422 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 401.422 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 401.422 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 407.984 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 407.984 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 407.984 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 407.984 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 407.984 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 407.984 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 407.984 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 407.984 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 414.551 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 414.551 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 414.551 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 414.551 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 414.551 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 414.551 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 414.551 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 414.551 288.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 246.172,
    r: 1.17189,
    transform: "rotate(90 421.113 246.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 258.359,
    r: 1.17189,
    transform: "rotate(90 421.113 258.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 270.547,
    r: 1.17189,
    transform: "rotate(90 421.113 270.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 282.735,
    r: 1.17189,
    transform: "rotate(90 421.113 282.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 252.267,
    r: 1.17189,
    transform: "rotate(90 421.113 252.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 264.454,
    r: 1.17189,
    transform: "rotate(90 421.113 264.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 276.641,
    r: 1.17189,
    transform: "rotate(90 421.113 276.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 288.828,
    r: 1.17189,
    transform: "rotate(90 421.113 288.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 5.11327 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 5.11327 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 5.11327 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 5.11327 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 5.11327 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 5.11327 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 5.11327 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 5.11327 337.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 11.1719 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 11.1719 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 11.1719 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 11.1719 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 11.1719 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 11.1719 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 11.1719 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 11.1719 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 17.7344 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 17.7344 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 17.7344 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 17.7344 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 17.7344 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 17.7344 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 17.7344 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 17.7344 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 24.3008 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 24.3008 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 24.3008 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 24.3008 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 24.3008 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 24.3008 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 24.3008 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 24.3008 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 30.8633 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 30.8633 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 30.8633 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 30.8633 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 30.8633 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 30.8633 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 30.8633 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 30.8633 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 37.4219 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 37.4219 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 37.4219 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 37.4219 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 37.4219 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 37.4219 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 37.4219 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 37.4219 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 43.9844 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 43.9844 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 43.9844 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 43.9844 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 43.9844 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 43.9844 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 43.9844 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 43.9844 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 50.5508 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 50.5508 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 50.5508 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 50.5508 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 50.5508 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 50.5508 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 50.5508 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 50.5508 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 57.1133 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 57.1133 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 57.1133 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 57.1133 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 57.1133 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 57.1133 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 57.1133 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 57.1133 337.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 63.1719 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 63.1719 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 63.1719 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 63.1719 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 63.1719 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 63.1719 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 63.1719 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 63.1719 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 69.7344 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 69.7344 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 69.7344 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 69.7344 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 69.7344 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 69.7344 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 69.7344 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 69.7344 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 76.3008 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 76.3008 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 76.3008 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 76.3008 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 76.3008 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 76.3008 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 76.3008 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 76.3008 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 82.8633 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 82.8633 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 82.8633 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 82.8633 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 82.8633 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 82.8633 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 82.8633 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 82.8633 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 89.4219 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 89.4219 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 89.4219 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 89.4219 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 89.4219 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 89.4219 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 89.4219 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 89.4219 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 95.9844 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 95.9844 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 95.9844 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 95.9844 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 95.9844 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 95.9844 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 95.9844 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 95.9844 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 102.551 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 102.551 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 102.551 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 102.551 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 102.551 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 102.551 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 102.551 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 102.551 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 109.113 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 109.113 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 109.113 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 109.113 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 109.113 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 109.113 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 109.113 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 109.113 337.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 115.172 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 115.172 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 115.172 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 115.172 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 115.172 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 115.172 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 115.172 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 115.172 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 121.734 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 121.734 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 121.734 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 121.734 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 121.734 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 121.734 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 121.734 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 121.734 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 128.301 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 128.301 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 128.301 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 128.301 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 128.301 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 128.301 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 128.301 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 128.301 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 134.863 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 134.863 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 134.863 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 134.863 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 134.863 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 134.863 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 134.863 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 134.863 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 141.422 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 141.422 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 141.422 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 141.422 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 141.422 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 141.422 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 141.422 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 141.422 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 147.984 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 147.984 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 147.984 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 147.984 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 147.984 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 147.984 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 147.984 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 147.984 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 154.551 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 154.551 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 154.551 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 154.551 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 154.551 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 154.551 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 154.551 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 154.551 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 161.113 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 161.113 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 161.113 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 161.113 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 161.113 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 161.113 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 161.113 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 161.113 337.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 167.172 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 167.172 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 167.172 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 167.172 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 167.172 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 167.172 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 167.172 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 167.172 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 173.734 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 173.734 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 173.734 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 173.734 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 173.734 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 173.734 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 173.734 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 173.734 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 180.301 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 180.301 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 180.301 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 180.301 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 180.301 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 180.301 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 180.301 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 180.301 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 186.863 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 186.863 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 186.863 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 186.863 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 186.863 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 186.863 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 186.863 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 186.863 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 193.422 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 193.422 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 193.422 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 193.422 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 193.422 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 193.422 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 193.422 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 193.422 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 199.984 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 199.984 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 199.984 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 199.984 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 199.984 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 199.984 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 199.984 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 199.984 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 206.551 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 206.551 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 206.551 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 206.551 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 206.551 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 206.551 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 206.551 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 206.551 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 213.113 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 213.113 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 213.113 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 213.113 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 213.113 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 213.113 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 213.113 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 213.113 337.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 219.172 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 219.172 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 219.172 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 219.172 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 219.172 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 219.172 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 219.172 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 219.172 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 225.734 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 225.734 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 225.734 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 225.734 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 225.734 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 225.734 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 225.734 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 225.734 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 232.301 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 232.301 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 232.301 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 232.301 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 232.301 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 232.301 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 232.301 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 232.301 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 238.863 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 238.863 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 238.863 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 238.863 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 238.863 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 238.863 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 238.863 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 238.863 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 245.422 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 245.422 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 245.422 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 245.422 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 245.422 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 245.422 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 245.422 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 245.422 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 251.984 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 251.984 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 251.984 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 251.984 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 251.984 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 251.984 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 251.984 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 251.984 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 258.551 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 258.551 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 258.551 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 258.551 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 258.551 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 258.551 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 258.551 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 258.551 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 265.113 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 265.113 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 265.113 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 265.113 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 265.113 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 265.113 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 265.113 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 265.113 337.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 271.172 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 271.172 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 271.172 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 271.172 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 271.172 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 271.172 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 271.172 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 271.172 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 277.734 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 277.734 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 277.734 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 277.734 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 277.734 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 277.734 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 277.734 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 277.734 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 284.301 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 284.301 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 284.301 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 284.301 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 284.301 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 284.301 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 284.301 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 284.301 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 290.863 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 290.863 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 290.863 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 290.863 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 290.863 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 290.863 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 290.863 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 290.863 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 297.422 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 297.422 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 297.422 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 297.422 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 297.422 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 297.422 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 297.422 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 297.422 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 303.984 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 303.984 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 303.984 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 303.984 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 303.984 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 303.984 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 303.984 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 303.984 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 310.551 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 310.551 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 310.551 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 310.551 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 310.551 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 310.551 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 310.551 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 310.551 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 317.113 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 317.113 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 317.113 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 317.113 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 317.113 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 317.113 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 317.113 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 317.113 337.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 323.172 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 323.172 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 323.172 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 323.172 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 323.172 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 323.172 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 323.172 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 323.172 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 329.734 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 329.734 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 329.734 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 329.734 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 329.734 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 329.734 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 329.734 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 329.734 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 336.301 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 336.301 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 336.301 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 336.301 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 336.301 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 336.301 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 336.301 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 336.301 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 342.863 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 342.863 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 342.863 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 342.863 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 342.863 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 342.863 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 342.863 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 342.863 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 349.422 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 349.422 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 349.422 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 349.422 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 349.422 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 349.422 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 349.422 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 349.422 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 355.984 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 355.984 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 355.984 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 355.984 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 355.984 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 355.984 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 355.984 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 355.984 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 362.551 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 362.551 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 362.551 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 362.551 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 362.551 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 362.551 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 362.551 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 362.551 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 369.113 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 369.113 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 369.113 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 369.113 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 369.113 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 369.113 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 369.113 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 369.113 337.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 375.172 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 375.172 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 375.172 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 375.172 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 375.172 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 375.172 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 375.172 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 375.172 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 381.734 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 381.734 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 381.734 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 381.734 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 381.734 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 381.734 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 381.734 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 381.734 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 388.301 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 388.301 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 388.301 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 388.301 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 388.301 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 388.301 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 388.301 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 388.301 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 394.863 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 394.863 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 394.863 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 394.863 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 394.863 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 394.863 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 394.863 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 394.863 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 401.422 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 401.422 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 401.422 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 401.422 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 401.422 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 401.422 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 401.422 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 401.422 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 407.984 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 407.984 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 407.984 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 407.984 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 407.984 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 407.984 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 407.984 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 407.984 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 414.551 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 414.551 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 414.551 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 414.551 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 414.551 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 414.551 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 414.551 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 414.551 337.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 295.172,
    r: 1.17189,
    transform: "rotate(90 421.113 295.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 307.359,
    r: 1.17189,
    transform: "rotate(90 421.113 307.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 319.547,
    r: 1.17189,
    transform: "rotate(90 421.113 319.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 331.735,
    r: 1.17189,
    transform: "rotate(90 421.113 331.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 301.267,
    r: 1.17189,
    transform: "rotate(90 421.113 301.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 313.454,
    r: 1.17189,
    transform: "rotate(90 421.113 313.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 325.641,
    r: 1.17189,
    transform: "rotate(90 421.113 325.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 337.828,
    r: 1.17189,
    transform: "rotate(90 421.113 337.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 5.11327 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 5.11327 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 5.11327 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 5.11327 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 5.11327 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 5.11327 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 5.11327 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.11327,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 5.11327 386.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 11.1719 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 11.1719 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 11.1719 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 11.1719 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 11.1719 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 11.1719 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 11.1719 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.1719,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 11.1719 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 17.7344 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 17.7344 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 17.7344 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 17.7344 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 17.7344 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 17.7344 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 17.7344 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.7344,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 17.7344 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 24.3008 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 24.3008 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 24.3008 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 24.3008 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 24.3008 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 24.3008 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 24.3008 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3008,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 24.3008 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 30.8633 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 30.8633 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 30.8633 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 30.8633 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 30.8633 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 30.8633 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 30.8633 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.8633,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 30.8633 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 37.4219 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 37.4219 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 37.4219 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 37.4219 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 37.4219 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 37.4219 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 37.4219 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.4219,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 37.4219 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 43.9844 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 43.9844 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 43.9844 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 43.9844 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 43.9844 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 43.9844 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 43.9844 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.9844,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 43.9844 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 50.5508 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 50.5508 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 50.5508 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 50.5508 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 50.5508 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 50.5508 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 50.5508 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5508,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 50.5508 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 57.1133 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 57.1133 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 57.1133 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 57.1133 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 57.1133 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 57.1133 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 57.1133 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.1133,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 57.1133 386.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 63.1719 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 63.1719 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 63.1719 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 63.1719 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 63.1719 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 63.1719 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 63.1719 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.1719,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 63.1719 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 69.7344 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 69.7344 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 69.7344 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 69.7344 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 69.7344 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 69.7344 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 69.7344 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.7344,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 69.7344 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 76.3008 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 76.3008 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 76.3008 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 76.3008 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 76.3008 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 76.3008 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 76.3008 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.3008,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 76.3008 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 82.8633 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 82.8633 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 82.8633 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 82.8633 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 82.8633 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 82.8633 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 82.8633 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.8633,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 82.8633 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 89.4219 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 89.4219 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 89.4219 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 89.4219 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 89.4219 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 89.4219 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 89.4219 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4219,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 89.4219 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 95.9844 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 95.9844 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 95.9844 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 95.9844 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 95.9844 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 95.9844 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 95.9844 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.9844,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 95.9844 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 102.551 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 102.551 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 102.551 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 102.551 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 102.551 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 102.551 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 102.551 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 102.551,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 102.551 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 109.113 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 109.113 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 109.113 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 109.113 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 109.113 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 109.113 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 109.113 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.113,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 109.113 386.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 115.172 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 115.172 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 115.172 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 115.172 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 115.172 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 115.172 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 115.172 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.172,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 115.172 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 121.734 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 121.734 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 121.734 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 121.734 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 121.734 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 121.734 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 121.734 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.734,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 121.734 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 128.301 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 128.301 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 128.301 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 128.301 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 128.301 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 128.301 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 128.301 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.301,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 128.301 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 134.863 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 134.863 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 134.863 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 134.863 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 134.863 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 134.863 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 134.863 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.863,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 134.863 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 141.422 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 141.422 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 141.422 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 141.422 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 141.422 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 141.422 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 141.422 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.422,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 141.422 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 147.984 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 147.984 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 147.984 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 147.984 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 147.984 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 147.984 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 147.984 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.984,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 147.984 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 154.551 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 154.551 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 154.551 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 154.551 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 154.551 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 154.551 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 154.551 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.551,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 154.551 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 161.113 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 161.113 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 161.113 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 161.113 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 161.113 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 161.113 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 161.113 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.113,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 161.113 386.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 167.172 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 167.172 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 167.172 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 167.172 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 167.172 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 167.172 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 167.172 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.172,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 167.172 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 173.734 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 173.734 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 173.734 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 173.734 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 173.734 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 173.734 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 173.734 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.734,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 173.734 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 180.301 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 180.301 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 180.301 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 180.301 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 180.301 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 180.301 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 180.301 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.301,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 180.301 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 186.863 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 186.863 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 186.863 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 186.863 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 186.863 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 186.863 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 186.863 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.863,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 186.863 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 193.422 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 193.422 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 193.422 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 193.422 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 193.422 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 193.422 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 193.422 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.422,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 193.422 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 199.984 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 199.984 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 199.984 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 199.984 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 199.984 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 199.984 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 199.984 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.984,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 199.984 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 206.551 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 206.551 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 206.551 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 206.551 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 206.551 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 206.551 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 206.551 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.551,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 206.551 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 213.113 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 213.113 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 213.113 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 213.113 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 213.113 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 213.113 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 213.113 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.113,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 213.113 386.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 219.172 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 219.172 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 219.172 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 219.172 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 219.172 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 219.172 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 219.172 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.172,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 219.172 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 225.734 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 225.734 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 225.734 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 225.734 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 225.734 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 225.734 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 225.734 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.734,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 225.734 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 232.301 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 232.301 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 232.301 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 232.301 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 232.301 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 232.301 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 232.301 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.301,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 232.301 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 238.863 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 238.863 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 238.863 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 238.863 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 238.863 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 238.863 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 238.863 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.863,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 238.863 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 245.422 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 245.422 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 245.422 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 245.422 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 245.422 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 245.422 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 245.422 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.422,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 245.422 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 251.984 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 251.984 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 251.984 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 251.984 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 251.984 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 251.984 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 251.984 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.984,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 251.984 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 258.551 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 258.551 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 258.551 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 258.551 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 258.551 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 258.551 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 258.551 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.551,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 258.551 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 265.113 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 265.113 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 265.113 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 265.113 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 265.113 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 265.113 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 265.113 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.113,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 265.113 386.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 271.172 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 271.172 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 271.172 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 271.172 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 271.172 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 271.172 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 271.172 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.172,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 271.172 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 277.734 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 277.734 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 277.734 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 277.734 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 277.734 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 277.734 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 277.734 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.734,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 277.734 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 284.301 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 284.301 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 284.301 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 284.301 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 284.301 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 284.301 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 284.301 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.301,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 284.301 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 290.863 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 290.863 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 290.863 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 290.863 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 290.863 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 290.863 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 290.863 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.863,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 290.863 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 297.422 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 297.422 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 297.422 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 297.422 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 297.422 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 297.422 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 297.422 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.422,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 297.422 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 303.984 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 303.984 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 303.984 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 303.984 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 303.984 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 303.984 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 303.984 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.984,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 303.984 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 310.551 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 310.551 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 310.551 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 310.551 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 310.551 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 310.551 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 310.551 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.551,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 310.551 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 317.113 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 317.113 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 317.113 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 317.113 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 317.113 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 317.113 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 317.113 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.113,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 317.113 386.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 323.172 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 323.172 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 323.172 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 323.172 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 323.172 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 323.172 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 323.172 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.172,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 323.172 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 329.734 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 329.734 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 329.734 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 329.734 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 329.734 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 329.734 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 329.734 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.734,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 329.734 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 336.301 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 336.301 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 336.301 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 336.301 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 336.301 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 336.301 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 336.301 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.301,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 336.301 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 342.863 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 342.863 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 342.863 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 342.863 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 342.863 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 342.863 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 342.863 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.863,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 342.863 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 349.422 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 349.422 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 349.422 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 349.422 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 349.422 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 349.422 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 349.422 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.422,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 349.422 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 355.984 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 355.984 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 355.984 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 355.984 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 355.984 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 355.984 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 355.984 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355.984,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 355.984 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 362.551 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 362.551 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 362.551 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 362.551 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 362.551 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 362.551 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 362.551 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362.551,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 362.551 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 369.113 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 369.113 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 369.113 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 369.113 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 369.113 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 369.113 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 369.113 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.113,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 369.113 386.828)",
    fill: "#F69F7F"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 375.172 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 375.172 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 375.172 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 375.172 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 375.172 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 375.172 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 375.172 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.172,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 375.172 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 381.734 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 381.734 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 381.734 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 381.734 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 381.734 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 381.734 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 381.734 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.734,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 381.734 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 388.301 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 388.301 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 388.301 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 388.301 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 388.301 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 388.301 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 388.301 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.301,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 388.301 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 394.863 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 394.863 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 394.863 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 394.863 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 394.863 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 394.863 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 394.863 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 394.863,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 394.863 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 401.422 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 401.422 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 401.422 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 401.422 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 401.422 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 401.422 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 401.422 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.422,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 401.422 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 407.984 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 407.984 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 407.984 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 407.984 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 407.984 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 407.984 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 407.984 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.984,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 407.984 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 414.551 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 414.551 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 414.551 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 414.551 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 414.551 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 414.551 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 414.551 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.551,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 414.551 386.828)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 344.172,
    r: 1.17189,
    transform: "rotate(90 421.113 344.172)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 356.359,
    r: 1.17189,
    transform: "rotate(90 421.113 356.359)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 368.547,
    r: 1.17189,
    transform: "rotate(90 421.113 368.547)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 380.735,
    r: 1.17189,
    transform: "rotate(90 421.113 380.735)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 350.267,
    r: 1.17189,
    transform: "rotate(90 421.113 350.267)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 362.454,
    r: 1.17189,
    transform: "rotate(90 421.113 362.454)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 374.641,
    r: 1.17189,
    transform: "rotate(90 421.113 374.641)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 421.113,
    cy: 386.828,
    r: 1.17189,
    transform: "rotate(90 421.113 386.828)",
    fill: "#F69F7F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_510_37086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 517,
    height: 386,
    fill: "white",
    transform: "translate(-94)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedbg);
export default __webpack_public_path__ + "static/media/dottedbg.0349c1dd513f1d339fbc35cc13d0d8f8.svg";
export { ForwardRef as ReactComponent };